import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "w-full h-full flex flex-row place-content-center" }
const _hoisted_4 = { class: "mr-1 self-center" }
const _hoisted_5 = { class: "mr-1 self-center" }
const _hoisted_6 = { class: "mr-1 self-center" }
const _hoisted_7 = { class: "mr-1 self-center" }
const _hoisted_8 = { class: "mr-1 self-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title.length != 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          textContent: _toDisplayString(_ctx.title),
          class: "font-bold mb-3 text-md uppercase"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Icon, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle(1))),
          source: _ctx.getImage(_ctx.star_1),
          width: _ctx.width
        }, null, 8, ["source", "width"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Icon, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggle(2))),
          source: _ctx.getImage(_ctx.star_2),
          width: _ctx.width
        }, null, 8, ["source", "width"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Icon, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggle(3))),
          source: _ctx.getImage(_ctx.star_3),
          width: _ctx.width
        }, null, 8, ["source", "width"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Icon, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggle(4))),
          source: _ctx.getImage(_ctx.star_4),
          width: _ctx.width
        }, null, 8, ["source", "width"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Icon, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggle(5))),
          source: _ctx.getImage(_ctx.star_5),
          width: _ctx.width
        }, null, 8, ["source", "width"])
      ])
    ])
  ]))
}